import { render, staticRenderFns } from "./tabsNavigation.vue?vue&type=template&id=d4fac3be&scoped=true&"
import script from "./tabsNavigation.vue?vue&type=script&lang=js&"
export * from "./tabsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./tabsNavigation.vue?vue&type=style&index=0&id=d4fac3be&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fac3be",
  null
  
)

export default component.exports